import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketCashPaymentSelectionStyled';
import { rem } from 'polished';

export const BasketCashPaymentSelectionAP = styled(BasketSelectSectionStyled)`
    .section {
        .description {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .summary {
            .otherPrices {
                .otherPrice {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                }
            }
        }
    }
`;
